import DataTable from "datatables.net-react";
import { Col, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';



function depositledger() {

  return (

    <div>
      <Card className="mt-2 ">
        <Card.Body>

          <Row>
            <Col className="text-start" >
              <b className="fss-05">SELECT </b>
              <Form.Select size="sm" className="text-black bg-light">
                <option>select</option>
              </Form.Select>
            </Col>


            <Col className="text-start">

              <b className="fss-05">ENTRY AFTER</b>
              <input type="date" name="bday" />

            </Col>

            <Col >

              <b className="fss-05">ENTRY BEFORE</b>
              <input type="date" name="bday" />

            </Col>

            <Col>
              <Button variant="secondary" className="fss-05 mt-4"><b>Submit</b></Button>{' '}

            </Col>

            <Col></Col>
            <Col></Col>
            <Col></Col>
            <Col></Col>

          </Row>


        </Card.Body>
      </Card>

      <Card className="mt-2">
        <Card.Body>

          <DataTable striped bordered hover className='mt-2'>
            <thead>
              <tr>
                <th className='bg-secondary fss-05' > NAME</th>
                <th className='bg-secondary fss-05' >DATE</th>
                <th className='bg-secondary fss-05' >DEBIT</th>
                <th className='bg-secondary fss-05' >CREDIT</th>
                <th className='bg-secondary fss-05' >REMARK</th>
                <th className='bg-secondary fss-05' >ACTION</th>


              </tr>
            </thead>
            <tbody className="bg-white">


            </tbody>
          </DataTable>

        </Card.Body>
      </Card>


    </div>



  );


}

export default depositledger;